module.exports = __webpack_public_path__ + "img/whiteSyngentaLogo.bde194b0.png";